import { render, staticRenderFns } from "./AcceptableUsePolicy.vue?vue&type=template&id=196fa2de&scoped=true&"
import script from "./AcceptableUsePolicy.vue?vue&type=script&lang=ts&"
export * from "./AcceptableUsePolicy.vue?vue&type=script&lang=ts&"
import style0 from "./AcceptableUsePolicy.vue?vue&type=style&index=0&id=196fa2de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196fa2de",
  null
  
)

export default component.exports